/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var collectionListSize = document.querySelectorAll(".collection-list-swiper");
if(collectionListSize.length > 0){
  var collectionListSwiper = Swiper;
  var init = false;

  function swiperMode() {
    if (window.innerWidth >= 1000) {
      if (!init) {
        init = true;
        collectionListSwiper = new Swiper(".collection-list-swiper", {
          slidesPerView: 6,
          spaceBetween: 0,
          navigation: {
            nextEl: ".collectionList-button-next",
            prevEl: ".collectionList-button-prev",
          },
        });
      }
    } else if (init) {
      collectionListSwiper.destroy();
      init = false;
    }
  }
  
  /* On Load
  **************************************************************/
  window.addEventListener('load', function() {
      swiperMode();
  });
  
  /* On Resize
  **************************************************************/
  window.addEventListener('resize', function () {
      swiperMode();
  });
}

if(document.querySelector('.search-bar__filter-label') != null){
  var searchLbl = document.querySelector('.search-bar__filter-label');
  searchLbl.addEventListener("click", event => {
    if(document.querySelector('.custom-search-product-type') != null){
      document.querySelector('.custom-search-product-type').classList.toggle("isOpen");
    }
  });
}
var typeLi = document.querySelectorAll('.custom-search-product-type li');
if(typeLi.length > 0){
  typeLi.forEach(el => {
      el.addEventListener("click", function(e) {
        console.log('dddd');
        
        var parent = el.closest('.custom-search-product-type');  
        parent.classList.remove("isOpen");
        //closeBigImgAndContainer(e);
      });
  });
}

document.body.addEventListener("click", function (e) {
  if(e.target.classList.length > 0){
    if(!e.target.classList.contains('search-bar__filter-active')){
      var ele = document.getElementsByClassName('custom-search-product-type')[0];
      if(ele != undefined){
        if(ele.classList.contains('isOpen')){
          ele.classList.remove("isOpen");
        }
      } 
    }
  }
}); 


function matchHeight(ul,grid,title,dg,tg,mg){
  var gridWrap = document.getElementsByClassName(ul)[0];
  if(typeof gridWrap != 'undefined' || gridWrap != null){
    var els = gridWrap.getElementsByClassName(grid);
    var initialStart = 0;
    var defaultHeight = 0;
    var totalGridCount = els.length - 1;
    var grid__count = 0;
    for(var i = 0; i < els.length; i++){
      initialStart = initialStart + 1;
      var currentHeight = els[i].getElementsByClassName(title)[0].offsetHeight;
      if(currentHeight > defaultHeight){
        defaultHeight = currentHeight;
      }
      var gridCount = dg;
      var gridCountMinus = dg - 1;
      
      var screencWidth = document.documentElement.clientWidth;
      if(screencWidth < 1280 && screencWidth > 640){
        var gridCount = tg;
        var gridCountMinus = tg - 1;
      }
      if(screencWidth < 641){
        var gridCount = mg;
        var gridCountMinus = mg - 1;
      }
      if(initialStart == gridCount || totalGridCount == i){
        var startIndex = grid__count;
        
        for(var j=startIndex; j<=i; j++){
          if(els[j]){
            els[j].getElementsByClassName(title)[0].style.minHeight = defaultHeight+'px';
              grid__count = grid__count + 1;
          }
        }
        initialStart = 0;
        defaultHeight = 0;
      }
    }
  }
}


matchHeight('product-list--collection','product-item--vertical','product-item__info',4,3,2);
matchHeight('collections-list','collection-list-item','collection-block-item__title',4,3,2);




equalHeight(false);


window.onresize = function(){
  equalHeight(true);
}

function equalHeight(resize) {
  var elements = document.querySelectorAll(".scroller__inner .product-item__info"),
      allHeights = [],
      i = 0;
  if(resize === true){
    for(i = 0; i < elements.length; i++){
      elements[i].style.height = 'auto';
    }
  }
  for(i = 0; i < elements.length; i++){
    var elementHeight = elements[i].clientHeight;
    allHeights.push(elementHeight);
  }
  for(i = 0; i < elements.length; i++){
    elements[i].style.height = Math.max.apply( Math, allHeights) + 'px';
    if(resize === false){
      elements[i].className = elements[i].className + " show";
    }
  }
}

    

function custom_addtocart(variantsId,qty,element) {
    
  var pbTempId = Number(variantsId);
  var pbTempQTY = Number(qty);
  var __this = element.closest('.header__action-item--cart');

  addItem(pbTempId, pbTempQTY);

  async function addItem(variantId, quantity) {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then((data) => {
      if(data.status === 200){  
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
         bubbles: true,
         detail: {
           quantity: 1
         }
        }));
      }else{
        console.log('cart-drawer error');
      }
    });
  }
}

window.onload = function(){
  if(window.location.href.indexOf('customer_posted=true#newsletter-newsletter') > -1 || window.location.href.indexOf('customer_posted=true') > -1){
    if(document.querySelector('.template-blog .blog-sidebar')){
      $('html, body').animate({
        scrollTop: $('.template-blog .blog-sidebar').offset().top - 130
      }, 500);
    }
  }

  if(document.documentElement.clientWidth > 1279){
    userToolTip();
  }else{
    userToolTip();
  }
}


function userToolTip() {
  var closeBtn = document.querySelector('.close_tooltip');
  closeBtn.addEventListener("click", function(e) {
    this.closest('.contact_tooltip').classList.add("close");
    if(document.documentElement.clientWidth < 1280){
      window.location.href = "/account";
    }
    if(document.cookie.indexOf('toolTip=') < 0){
      setCookie();
    }
    
  });

  var tooltipBtn = document.querySelector('.tooltip_wrapper svg');
  var tooltipContact = document.querySelector('.contact_tooltip');
  var userIcon = document.querySelector('.header__account-icon');
  
  if(document.documentElement.clientWidth > 1279){
    tooltipBtn.addEventListener("mouseenter",(event) => {
      tooltipContact.classList.remove("close");
      }
    );
  }else{
    tooltipBtn.addEventListener("click",(event) => {
        tooltipContact.classList.remove("close");
      }
    );
    
    userIcon.addEventListener("click",(event) => {
      tooltipContact.classList.toggle("show_mobile");
      if(!tooltipContact.classList.contains("show_mobile")){
        window.location.href = "/account";
      }
    });
    
    document.body.addEventListener("click", function (evt) {
      if(tooltipContact.classList.contains("show_mobile")){
        tooltipContact.classList.remove("show_mobile");
      }
    });
  }

  document.querySelector('.header__action-item--account').addEventListener("click",(event) => {
    event.stopPropagation();
  });

  tooltipContact.classList.add("show_box");

  var read_cookies = document.cookie;
  var split_read_cookie = read_cookies.split( ";" );
  for ( i = 0; i < split_read_cookie.length; i++ ){
    var value = split_read_cookie[i];
    value = value.split( "=" );
    if( value[0] == " toolTip" && value[1] == "yes" ){
      tooltipContact.classList.remove("show_box");
    }
  }
  
  document.body.addEventListener("click", function (evt) {
    if(tooltipContact.classList.contains("show_box")){
      tooltipContact.classList.remove("show_box");
      setCookie();
    }
  });

}

function setCookie() {
  var timeToAdd = 1000 * 60 * 60 * 24 * 10;
  // var timeToAdd = 1000 * 30 ;
  var date = new Date();
  var expiryTime = parseInt(date.getTime()) + timeToAdd;
  date.setTime(expiryTime);
  var utcTime = date.toUTCString();
  document.cookie = "toolTip=yes; expires=" + utcTime + ";";
}


recursive();
function recursive(){
  var optionsLength = document.querySelectorAll('.vertex-collection-wishlist').length;
  if(optionsLength > 0){
    matchHeight('product-list--collection','product-item--vertical','product-item__info',4,3,2);
    return false;

  }else{
    setTimeout(function(){
      recursive();
    },300);
  }
}

